/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class ActivityContactShortVo {

    activityUuid: string | undefined = undefined;

    customerContactUuid: string | undefined = undefined;

    contactName: string | undefined = undefined;

    buyingRoleValue: string | undefined = undefined;

    phoneNumber: string | undefined = undefined;

    contactTypeValue: string | undefined = undefined;

    markedToDelete: boolean | undefined = undefined;

}
